module.exports = __webpack_public_path__ + "static/LTUnivers-BasicRegular-1d5ed162d4f55135857dfdd2fe6ca1c5.otf";